import { render, staticRenderFns } from "./SidecartLineItemKit.vue?vue&type=template&id=a9fb509c&scoped=true&lang=pug&"
import script from "./SidecartLineItemKit.vue?vue&type=script&lang=js&"
export * from "./SidecartLineItemKit.vue?vue&type=script&lang=js&"
import style0 from "./SidecartLineItemKit.vue?vue&type=style&index=0&id=a9fb509c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9fb509c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9fb509c')) {
      api.createRecord('a9fb509c', component.options)
    } else {
      api.reload('a9fb509c', component.options)
    }
    module.hot.accept("./SidecartLineItemKit.vue?vue&type=template&id=a9fb509c&scoped=true&lang=pug&", function () {
      api.rerender('a9fb509c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/cart/SidecartLineItemKit.vue"
export default component.exports